import { AppliedDiscount, DiscountEntity } from '../../types/orders'
import React from 'react'
import { RewardsCard } from './RewardsCard'
import {
  AvailableRedemption,
  RewardType,
  SelectionType
} from '../../types/loyalty'

export const rewardToDiscount = (
  r: AvailableRedemption,
  vendor: string,
  discount: DiscountEntity
): AppliedDiscount | undefined => {
  if (isCheckDiscount(r)) {
    return buildCheckDiscount(r, vendor, discount)
  } else if (isItemDiscount(r)) {
    return undefined
  }

  return undefined
}

const buildCheckDiscount = (
  r: AvailableRedemption,
  vendor: string,
  discount: DiscountEntity
): AppliedDiscount | undefined => {
  return {
    discount: {
      guid: r.itemId,
      entityType: 'Discount'
    },
    loyaltyDetails: {
      referenceId: r.referenceId,
      vendor: vendor
    },
    name: discount.name,
    discountAmount: getRewardAmount(r, vendor),
    discountPercent: getRewardPercent(r, vendor)
  }
}

const getRewardAmount = (
  r: AvailableRedemption,
  vendor: string
): number | undefined => {
  if (vendor === 'TOAST') {
    return r.cashbackValue
  }
  if (vendor === 'INTEGRATION') {
    return r.integrationData!!.amount
  }
}

const getRewardPercent = (
  r: AvailableRedemption,
  vendor: string
): number | undefined => {
  if (vendor === 'TOAST') {
    // 1st party doesn't support percentage discounts
    return undefined
  }
  if (vendor === 'INTEGRATION') {
    return r.integrationData!!.amount
  }
}

export const isCheckDiscount = (r: AvailableRedemption): Boolean => {
  return (
    r.referenceId === RewardType.LOYALTY_DOLLARS_AMOUNTS ||
    r.integrationData?.selectionType === SelectionType.CHECK
  )
}

export const isItemDiscount = (r: AvailableRedemption): Boolean => {
  return (
    r.referenceId === RewardType.ITEM_REWARDS ||
    r.integrationData?.selectionType === SelectionType.ITEM
  )
}

export interface RedemptionView {
  key: number
  redemption: AvailableRedemption
}

export const rewardToCard = (redemptionView: RedemptionView) => {
  const r = redemptionView.redemption

  const title = r.currentState?.messages?.rewardValueMessage
  const subtitle = r.currentState?.messages?.rewardLabelMessage

  return {
    value: redemptionView.key,
    contents: <RewardsCard title={title} subtitle={subtitle} />
  }
}
